export default __webpack_public_path__ + "static/media/diavasi_tiflon.780fb2b4.svg";